<template>
  <router-view />
</template>

<script>
export default {
  name: "AccountPage",
};
</script>
